import { QRScannerServiceApi } from "@/api";
import store from "@/store";
import firebase from 'firebase/app';
import 'firebase/database';
import {
  Module,
  VuexModule,
  MutationAction,
  getModule,
} from "vuex-module-decorators";
import { EventInfo, EventLoginRequest, IAuthState } from "./types";

const db = firebase
  .initializeApp({ databaseURL: 'https://equipovision.firebaseio.com' })
  .database()

const initialState = Object.freeze<IAuthState>({
  //   user: null,
  eventID: "",
  token: sessionStorage.getItem("token"),
  error: "",
  success: false,
  eventInfo: {} as EventInfo,
});

@Module({ dynamic: true, store, name: "Auth" })
class Auth extends VuexModule implements IAuthState {
  eventID: string = initialState.eventID;
  token: string | null = initialState.token;
  error: string = initialState.error;
  success: boolean = initialState.success;
  eventInfo: EventInfo = initialState.eventInfo;
  static eventFbRef: any = null;
  static currentNode: any = null;
  static qrScanCounter: number;
  static _eventInfo: EventInfo;

  public get currentTime() {
    return new Date().getTime();
  }

  public get currentEventLoginSuccess(): boolean {
    return this.success;
  }

  public get currentError(): string {
    return this.error;
  }

  public get currentEventToken(): string | null {
    return this.token;
  }

  public get currentEventID(): string {
    return this.eventID;
  }
  public get currentEventInfo(): EventInfo {
    return this.eventInfo;
  }
  @MutationAction
  public async EventLogin(request: EventLoginRequest): Promise<IAuthState> {
    const response = await QRScannerServiceApi.EventLogin(request);

    const newResponse: any = response;

    // && eventDate > currentDate
    if (response.success === true) {
      sessionStorage.setItem("token", newResponse.data.token);
      newResponse.data.eventInfo.eventQRCount = Auth.qrScanCounter;
      console.log('Crear Listener FB Here');
      Auth.RegisterCounterListener( newResponse.data.eventID+"" , newResponse.data.eventInfo.eventType, newResponse.data.eventInfo);
      return {
        eventID: newResponse.data.eventID,
        token: newResponse.data.token,
        error: newResponse.error,
        success: newResponse.success,
        eventInfo: newResponse.data.eventInfo,
      };
    } else {
      return {
        eventID: "",
        error: response.error,
        success: response.success,
        token: null,
        eventInfo: (response as any).data?.eventInfo || ({} as EventInfo),
      };
    }
  }

  @MutationAction<IAuthState>({
    mutate: ["eventID", "token", "eventInfo"],
  })
  public async LogoutUser(): Promise<IAuthState> {
    // await AuthApi.logout();

    sessionStorage.clear();
    return {
      ...initialState,
    };
  }

  @MutationAction
  public async GetEventInfo(): Promise<Partial<IAuthState> | null> {
    const response = await QRScannerServiceApi.GetEventInfo();
    // console.log(response);
    if (response === null) {
      return {
        ...initialState,
      };
    }

    try {
      if ( response.success === true && response.data.eventInfo.eventColor ) {
        const style: any = document.getElementById("app")!.style;
        style["background-color"] = response.data.eventInfo.eventColor;
      }
    } catch(_err) {
      console.log("Auth Change BG Color ERR", _err);
    }

    console.log('Re-Create Listener FB Here');
    Auth.RegisterCounterListener( response.data.eventID+"" ,response.data.eventInfo.eventType, response.data.eventInfo );
    response.data.eventInfo.eventQRCount = Auth.qrScanCounter;
    Auth._eventInfo = response.data.eventInfo;
    return {
      error: response.error,
      success: response.success,
      eventInfo: response.data.eventInfo,
      eventID: response.data.eventID,
    };
  }
  
  static RegisterCounterListener(eventID: string, type: string, eventInfo: EventInfo): void {
    if (!eventID || !type) {
      return;
    }
    if (Auth.currentNode != null) {
      // Auth.eventFbRef.off('child_changed', Auth.fbOnchangeNode);
      Auth.eventFbRef.off('value', Auth.fbOnchangeNode);
    } else {
      Auth.currentNode = `QR_SCAN_COUNTER/${eventID}`;
      Auth.eventFbRef = db.ref(this.currentNode);
    }
    if (`${type}`.toLowerCase() === "workshop") {
      // Auth.eventFbRef.on('child_changed', Auth.fbOnchangeNode);
      Auth.eventFbRef.on('value', Auth.fbOnchangeNode);
      console.log('FB Listener Created => ', Auth.currentNode);
      eventInfo.eventQRCount = 0;
      Auth._eventInfo = eventInfo;
    }
  }

  static fbOnchangeNode(snapshot: any): void {
    if (snapshot.val() == null) return;
    Auth.qrScanCounter = Object.keys(snapshot.val()).length;
    console.log("QR Scan Counter => ", Auth.qrScanCounter);
    if (Auth._eventInfo) {
      console.log("Update value En Event Info", Auth.qrScanCounter);
      Auth._eventInfo.eventQRCount = Auth.qrScanCounter;
    }
  }
}

export const AuthModule = getModule(Auth);
